/** Function that processes an AND `filter` input into what's expected by the API.
 *
 * @example
 * ```typescript
 * makeAndFiltersForQuery({
 *   and: {
 *     provider_id: [123, 456],
 *   },
 *   or: {
 *     location_id: [8910, 8911]
 *   }
 * });
 * // Produces the following array:
 * // ['provider_id:123', 'provider_id:456', 'location_id:8910#8911']
 * ```
 */
export function makeAndFiltersForQuery(filter) {
    const result = [];
    const processSubAnd = (and) => {
        Object.entries(and !== null && and !== void 0 ? and : {}).forEach(([key, vals]) => {
            if (Array.isArray(vals)) {
                vals.forEach((val) => {
                    result.push(`${key}:${val}`);
                });
            }
            else {
                result.push(`${key}:${vals}`);
            }
        });
    };
    processSubAnd(filter.and);
    const processSubOr = (or) => {
        Object.entries(or !== null && or !== void 0 ? or : {}).forEach(([key, vals]) => {
            result.push(`${key}:${Array.isArray(vals) ? vals.join('#') : vals}`);
        });
    };
    processSubOr(filter.or);
    return result;
}
/** Function that processes an OR `_filter` input into what's expected by the API.
 *
 * @example
 * ```typescript
 * makeOrFiltersForQuery({
 *   provider_id: [123, 456, 789],
 *   location_id: [8910]
 * });
 * // Produces the following array:
 * // ['provider_id:123#456#789', 'location_id:8910']
 * ```
 */
export function makeOrFiltersForQuery(filters) {
    const result = [];
    Object.entries(filters).forEach(([key, vals]) => {
        result.push(`${key}:${Array.isArray(vals) ? vals.join('#') : vals}`);
    });
    return result;
}
/** Function that processes an NEGATIVE `-filter` input into what's expected by the API.
 *
 * @example
 * ```typescript
 * makeNegativeFilterForQuery({
 *   provider_id: [123, 456, 789],
 *   location_id: [8910]
 * });
 * // Produces the following array:
 * // ['provider_id:123', 'provider_id:456', 'provider_id:789', 'location_id:8910']
 * ```
 */
export function makeNegativeFilterForQuery(filters) {
    const result = [];
    Object.entries(filters).forEach(([key, vals]) => {
        if (Array.isArray(vals)) {
            vals.forEach((val) => {
                result.push(`${key}:${val}`);
            });
        }
        else {
            result.push(`${key}:${vals}`);
        }
    });
    return result;
}
//# sourceMappingURL=filter.js.map